export const nextPublicChecklistPatchBatch = (
  token: string,
  pending: Record<string, string | null>
): Record<string, string | null> => {
  const changes: Record<string, string | null> = {};
  for (const [id, value] of Object.entries(pending)) {
    const candidate = { ...changes, [id]: value };
    if (Object.keys(candidate).length > 40 || JSON.stringify({ token, changes: candidate }).length > 24000) {
      if (!Object.keys(changes).length) {
        throw new Error('Um campo excede o tamanho permitido. Reduza o texto e tente salvar novamente.');
      }
      break;
    }
    changes[id] = value;
  }
  return changes;
};
